import React, { FC, useCallback, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import SignatureCanvas from 'react-signature-canvas';

// import { sendMail, verifyDomain } from '../../../firebase/functions';
import { useWizard, WizardData, WizardStep } from '../../../contexts/WizardContext';
import Layout from '../../Layout';
import Button from '../../shared/buttonComponents/Button';
import VideoComponent from '../../shared/VideoComponent';
import { useMediaQuery } from '../../../contexts/MediaQueryContext';


// const sigRef = useRef(null);
//
// const handle = useCallback(() => {
//   const a = (sigRef.current as any).toDataURL();
//
//   console.log(a);
//   debugger;
// }, [sigRef]);
//
// return (
//   <div>
//     <SignatureCanvas
//       ref={sigRef}
//       penColor='green'
//       canvasProps={{ width: 500, height: 200, className: 'sigCanvas' }}
//     />
//
//     <div onClick={handle}>Get info</div>
//   </div>
// )

export interface FormInputs {
  fullName: string;
  title: string;
  companyName: string;
  companyRegisteredAddress: string;
  companyRegistrationNumber: string;
  urlList: string;
  email: string;
  signature: string;
}

interface SignatureFormInputs {
  fullName: string;
  title: string;
  companyName: string;
  companyRegisteredAddress: string;
  companyRegistrationNumber: string;
  urlList: string;
  email: string;

}

interface ContentInterface {
  data: WizardData;
  contactData: SignatureFormInputs;
}

const FormOther: FC = (): JSX.Element => {

  const addressPlaceholderMobile = 'Company Registered Address \n(As appears in incorporation documents) ';
  const addressPlaceholderDesktop = 'Company Registered Address (As appears in incorporation documents) ';
  const companyNameMobile = 'Company Name \n(As appears in incorporation documents)';
  const companyNameDesktop = 'Company Name (As appears in incorporation documents)';

  const {
    changeStep
  } = useWizard();

  const { onMobile } = useMediaQuery();

  const { register, handleSubmit, errors } = useForm<SignatureFormInputs>();
  const [isSending, setIsSending] = useState<boolean>(false);

  const onSubmit = useCallback(async (contactData: SignatureFormInputs) => {
    setIsSending(true);

    // // Website domain validation
    // const websiteDomain = new URL(contactData.website).hostname;
    //
    // if (!websiteDomain) {
    //   setError('website', { message: 'Provide valid URL', type: 'pattern' });
    //   setIsSending(false);
    //   return;
    // }
    //
    // const websiteDNSRecords = await verifyDomain(websiteDomain);
    //
    // if (websiteDNSRecords.A.length === 0) {
    //   setError('website', { message: 'Provide valid URL', type: 'pattern' });
    //   setIsSending(false);
    //   return;
    // }
    //
    // clearErrors('website');

    // Email domain validation
    // const [, emailDomain] = contactData.email.split('@');
    //
    // if (!emailDomain) {
    //   setError('email', { message: 'Provide valid E-Mail', type: 'pattern' });
    //   setIsSending(false);
    //   return;
    // }
    //
    // const emailDNSRecords = await verifyDomain(emailDomain);
    //
    // if (emailDNSRecords.A.length === 0 || emailDNSRecords.MX.length === 0) {
    //   setError('email', { message: 'Provide valid E-Mail', type: 'pattern' });
    //   setIsSending(false);
    //   return;
    // }
    //
    // clearErrors('email');

    // try {
    //   await sendMail({
    //     wizardData: data,
    //     contactData
    //   });
    //
    changeStep(WizardStep.THANK_YOU);
    // } catch (e) {
    //   console.error(e);
    //   setIsSending(false);
    // }
  }, [changeStep]);

  const [focused, setFocused] = useState<string>('');
  const isFocused = useCallback((name) => name === focused ? 'is-focused' : '', [focused]);

  const emailCheck = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  // const URLCheck = /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[\-;:&=\+\$,\w]+@)?[A-Za-z0-9\.\-]+|(?:www\.|[\-;:&=\+\$,\w]+@)[A-Za-z0-9\.\-]+)((?:\/[\+~%\/\.\w\-_]*)?\??(?:[\-\+=&;%@\.\w_]*)#?(?:[\.\!\/\\\w]*))?)/;

  const sigRef = useRef(null);

  const clearCanvas = () => {
    // @ts-ignore
    return sigRef.current.clear();
  };

  // const handle = useCallback(() => {
  //   const a = (sigRef.current as any).toDataURL();
  //
  //   console.log(a);
  //   debugger;
  // }, [sigRef]);

  return (
    <Layout>

      <form
        // onSubmit={handleSubmit(onSubmit)}
        className={onMobile ? 'form-other-container-mobile' : 'form-other-container'}
      >
        <div className="form-signature-close">
          <img
            onClick={() => changeStep(WizardStep.EXPENDED_MONTHLY_VOLUME)}
            src={onMobile
              ? `${process.env.PUBLIC_URL}/assets/images/X2x.png`
              : `${process.env.PUBLIC_URL}/assets/images/close-icon.png`}
            alt=""
          />
        </div>

        <div className="form-signature-title-box">
          <div className="form-signature-title-icon-mobile">
            <VideoComponent
              src={`${process.env.PUBLIC_URL}/assets/videos/signature.webm`}
              fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/signature.png`}
            />
          </div>

          <div className="form-signature-title">

            <p>
              You've reached the final stage of getting your price proposal.
            </p>
          </div>

          <div className="form-signature-title-icon">
            <VideoComponent
              src={`${process.env.PUBLIC_URL}/assets/videos/signature.webm`}
              fallbackImage={`${process.env.PUBLIC_URL}/assets/images/pages/signature.png`}
            />
          </div>
        </div>

        <div className="form-signature-input-box">
          <div className={`form-signature-input-container ${isFocused('full-name')}`}>
            <input
              ref={register({
                required: 'Full Name is required'
              })}
              name="fullName"
              onFocus={() => setFocused('full-name')}
              onBlur={() => setFocused('')}
              id="full-name"
              type="text"
              placeholder='Full Name'
            />
          </div>
          <ErrorMessage name="fullName" errors={errors} as='p'/>

          <div className={`form-signature-input-container ${isFocused('title')}`}>
            <input
              ref={register({
                required: 'Last Name is required'
              })}
              name="title"
              onFocus={() => setFocused('title')}
              onBlur={() => setFocused('')}
              id="title"
              type="text"
              placeholder='Title'
            />
          </div>
          <ErrorMessage name="title" errors={errors} as='p'/>

          <div className={`form-signature-input-container ${isFocused('company-name')}`}>
            <textarea
              ref={register({
                required: 'Company Name is required'
              })}
              name="companyName"
              onFocus={() => setFocused('company-name')}
              onBlur={() => setFocused('')}
              id="companyID"
              placeholder={onMobile ? companyNameMobile : companyNameDesktop}
            />
          </div>
          <ErrorMessage name="companyName" errors={errors} as='p'/>


          <div className={`form-signature-input-container ${isFocused('company-registered-address')}`}>
            <textarea
              ref={register({
                required: 'Company Registered Address is required'
              })}
              name="companyRegisteredAddress"
              onFocus={() => setFocused('company-registered-address')}
              onBlur={() => setFocused('')}
              id="companyRegisteredAddress"
              placeholder={onMobile ? addressPlaceholderMobile : addressPlaceholderDesktop}
            />
          </div>
          <ErrorMessage name="companyRegisteredAddress" errors={errors} as='p'/>

          <div className={`form-signature-input-container ${isFocused('company-registration-number')}`}>
            <input
              ref={register({
                required: 'Company Registration Number is required',
              })}
              name="companyRegistrationNumber"
              onFocus={() => setFocused('company-registration-number')}
              onBlur={() => setFocused('')}
              id="company-registration-number"
              type="text"
              placeholder='Company Registration Number'
            />
          </div>
          <ErrorMessage name="companyRegistrationNumber" errors={errors} as='p'/>


          <div className={`form-signature-input-container ${isFocused('url-list')}`}>
            <input
              ref={register({
                required: 'URL list is required',
              })}
              name="urlList"
              onFocus={() => setFocused('url-list')}
              onBlur={() => setFocused('')}
              id="urlList"
              type="text"
              placeholder='URL List'
            />
          </div>
          <ErrorMessage name="urlList" errors={errors} as='p'/>


          <div className={`form-signature-input-container ${isFocused('email')}`}>
            <input
              ref={register({
                required: true,
                pattern: emailCheck
              })}
              name="email"
              onFocus={() => setFocused('email')}
              onBlur={() => setFocused('')}
              id="emailID"
              type="email"
              placeholder='E-Mail'
            />
          </div>
          {errors.email && errors.email.type === 'required' && <p>Email is required</p>}
          {errors.email && errors.email.type === 'pattern' && <p>Provide valid Email</p>}

          <span>By signing here, you will receive our terms of use to your email:</span>
          <div className={`signature-input-container ${isFocused('signature')}`}>
            <div className='canvas-top'>
              <label className='msg-box'>Signature</label>
              <div className='clear-canvas' onClick={clearCanvas}>Clear</div>
            </div>
            <div className='sign-box'>
              <SignatureCanvas
                ref={sigRef}
                penColor='black'
                clearOnResize={true}
                canvasProps={{ className: 'sigCanvas' }}
              />
            </div>
          </div>
          <ErrorMessage name="signature" errors={errors} as='p'/>
        </div>

        <div className="form-signature-button">
          <Button
            title={isSending ? 'Sending ...' : 'Send'}
            disabled={isSending}
            onClick={handleSubmit(onSubmit)}
            // onClick={() => changeStep(WizardStep.THANK_YOU)}
          />
        </div>
      </form>

    </Layout>
  );
};

export default FormOther;
